import Slider from "react-slick";
import {
  Box,
  Container,
  Typography,
  Avatar,
  Paper,
} from "@mui/material";
import img1 from "../assets/images/p1.jpg";
import img2 from "../assets/images/p2.jpg";
import img3 from "../assets/images/p3.jpg";


const cultureMoments = [
    { image: img1 },
  { image: img2 },
  { image: img3 },
];

export default function OfficeCultureSection() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 700,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 6000,
  };

  return (
    <Box
      sx={{
        py: 10,
        background: "linear-gradient(to bottom right, #7AB2D3, #c3e97d)",
      }}
    >
      <Container maxWidth="md">
        <Typography
          variant="h4"
          align="center"
          sx={{
            color: "#ffffff",
            fontWeight: 700,
            mb: 3,
            textTransform: "uppercase",
            letterSpacing: 1.5,
            textShadow: "1px 1px 4px rgba(0,0,0,0.4)",
          }}
        >
          Life at Claysoft
        </Typography>
        <Typography variant="body1" align="center" color="#ffffff" mb={6}>
          A glimpse into our culture, people, and memories we create together.
        </Typography>

        <Slider {...settings}>
          {cultureMoments.map((moment, index) => (
            <Paper
              key={index}
              elevation={3}
              sx={{
                height: { xs: 250, md: 400 },
                borderRadius: 4,
                // backgroundImage: `url(${moment})`,
                backgroundImage: `url(${moment.image})`,

                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                position: "relative",
                boxShadow: 6,
              }}
            >
             
            </Paper>
          ))}
        </Slider>
      </Container>
    </Box>
  );
}


// import React from "react";
// import Slider from "react-slick";
// import {
//   Box,
//   Container,
//   Typography,
//   Avatar,
//   Rating,
//   Paper,
// } from "@mui/material";

// const testimonials = [
//   {
//     name: "John Doe",
//     role: "CEO, TechCorp",
//     text: "Claysoft delivered beyond expectations. Their team is highly professional and efficient!",
//     rating: 5,
//     image: "https://randomuser.me/api/portraits/men/32.jpg",
//   },
//   {
//     name: "Jane Smith",
//     role: "CTO, Finware",
//     text: "We saw a 40% boost in efficiency after implementing their software. Highly recommend.",
//     rating: 4.5,
//     image: "https://randomuser.me/api/portraits/women/44.jpg",
//   },
//   {
//     name: "Alex Johnson",
//     role: "Founder, Innovatek",
//     text: "Their consulting service transformed our digital infrastructure in just weeks.",
//     rating: 4,
//     image: "https://randomuser.me/api/portraits/men/85.jpg",
//   },
// ];

// export default function TestimonialSection() {
//   const settings = {
//     dots: true,
//     infinite: true,
//     speed: 700,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     autoplay: true,
//     autoplaySpeed: 6000,
//   };

//   return (
//                                       //  "#f1f8f6" 
//     <Box sx={{ py: 10, 
//     // backgroundColor: "#F5DEB3"
//         background  : "linear-gradient(to bottom right, #7AB2D3, #c3e97d )",
//     }}>
//       <Container maxWidth="md">
//         <Typography variant="h4" align="center" color="#fff" gutterBottom
//         sx={{
//           color: "#ffffff",
//             fontWeight: 700,
//             mb: 5,
//             textTransform: "uppercase",
//             letterSpacing: 1.5,
//             textShadow: '1px 1px 4px rgba(0,0,0,0.4)',
//         }}
//         >
//           What Our Clients Say
//         </Typography>
//         <Typography
//           variant="body1"
//           align="center"
//           // color="text.secondary"
//           color="#ffffff"
//           mb={6}
//         >
//           Real feedback from our happy customers.
//         </Typography>

//         <Slider {...settings}>
//           {testimonials.map((testimonial, index) => (
//             <Paper
//               key={index}
//               elevation={3}
//               sx={{
//                 p: 4,
//                 textAlign: "center",
//                 borderRadius: 3,
//                 // backgroundColor: "#ffffff",
//                 backgroundColor: "transparent",
//               }}
//             >
//               <Avatar
//                 alt={testimonial.name}
//                 src={testimonial.image}
//                 sx={{ width: 80, height: 80, mx: "auto", mb: 2 }}
//               />
//               <Typography variant="h6" gutterBottom>
//                 {testimonial.name}
//               </Typography>
//               <Typography variant="subtitle2" color="text.secondary" mb={2}>
//                 {testimonial.role}
//               </Typography>
//               <Rating
//                 name={`rating-${index}`}
//                 value={testimonial.rating}
//                 precision={0.5}
//                 readOnly
//                 sx={{ mb: 2 }}
//               />
//               <Typography variant="body1" color="text.primary">
//                 “{testimonial.text}”
//               </Typography>
//             </Paper>
//           ))}
//         </Slider>
//       </Container>
//     </Box>
//   );
// }


// 
